import { Sparkles, Leaf, BarChart3, GraduationCap, Award, CloudRain } from "lucide-react";

const FEATURES = [
  { icon: Leaf, title: "Crop Disease Detection", body: "Photo analysis that identifies plant diseases and prescribes treatments in real time." },
  { icon: BarChart3, title: "Smart Voting Analytics", body: "Fraud-free audience voting powered by machine learning integrity checks." },
  { icon: Sparkles, title: "Market Price Intelligence", body: "Live commodity price tracking across 36 Nigerian state markets." },
  { icon: GraduationCap, title: "Personalised Learning", body: "Custom agric training in English, Hausa, Igbo, and Yoruba." },
  { icon: Award, title: "Contestant Scoring", body: "Objective 7-criteria performance scoring every episode." },
  { icon: CloudRain, title: "Climate & Weather Data", body: "Hyper-local farm-level weather alerts and forecasting." },
];

const AI_IMG =
  "https://customer-assets.emergentagent.com/job_farm-show-hub/artifacts/n4ksfwop_image.png";

export default function BagoAI() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24">
      <div className="grid md:grid-cols-2 gap-12 items-center">
        <div>
          <div className="text-xs uppercase tracking-[0.3em] text-[#F26A1F] mb-5">
            Governor Bago
          </div>
          <h1
            className="text-5xl md:text-6xl font-black tracking-tighter leading-[0.95] mb-6"
            style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
          >
            Thinks like a <span className="text-[#2BA84A]">farmer</span>.<br />
            Works like a <span className="text-[#F26A1F]">scientist</span>.<br />
            Honours a legend.
          </h1>
          <p className="text-white/70 leading-relaxed">
            Governor Bago is named in honour of His Excellency Governor Mohammed
            Umar Bago of Niger State, the "Farmer Governor", for his
            commitment to making agriculture a serious, profitable, and
            aspirational business. Governor Bago carries that legacy into the
            future, training and guiding young Nigerian farmers in real time.
          </p>
        </div>
        <div className="relative aspect-square border border-white/10 overflow-hidden bg-black">
          <img src={AI_IMG} alt="Governor Bago" className="w-full h-full object-contain" />
        </div>
      </div>

      <section className="mt-24">
        <div className="text-xs uppercase tracking-[0.3em] text-[#1E8E3E] mb-4">
          Capabilities
        </div>
        <h2
          className="text-3xl md:text-4xl font-bold tracking-tighter mb-12"
          style={{ fontFamily: "'Cabinet Grotesk', 'Bricolage Grotesque', sans-serif" }}
        >
          Six tools. One agricultural brain.
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {FEATURES.map((f) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                className="p-7 border border-white/10 hover:border-[#F26A1F]/60 transition-colors group bg-black"
              >
                <Icon size={26} className="text-[#F26A1F] mb-5 group-hover:scale-110 transition-transform" />
                <h3 className="text-lg font-bold tracking-tight mb-2">{f.title}</h3>
                <p className="text-sm text-white/60 leading-relaxed">{f.body}</p>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
